import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/totalRevenueSalesSagas";
import ToggleableButton from "../../../../components/toggleableButton/toggleableButton";

const ShowExpenses = () => {
  const dispatch = useDispatch();
  const showExpenses = useSelector(
    (state) => state.totalRevenueSales.selectedFilters.show_expenses
  );

  return (
    <ToggleableButton
      isActive={showExpenses}
      isRadio
      title="total-revenue-sales-show-expenses"
      onClick={(data) => dispatch(actionCreators.updateShowExpenses(data))}
    />
  );
};

export default ShowExpenses;
